import { AxiosInstance } from "axios";
import { Icheckin } from "../common";

export const QRcode = (axiosInstance: AxiosInstance) => {
  const apiBaseUrlUser = "api/user";
  const apiBaseUrlAgenda = "api/agenda";
  return {
    getdatauserByagendaid: async (user: string | null) => {
      return await axiosInstance
        .get(`${apiBaseUrlUser}/${user}`)
        .then((result) => result.data);
    },
    getdataagendaByagendaid: async (agenda: string | null) => {
      return await axiosInstance
        .get(`${apiBaseUrlAgenda}/${agenda}`)
        .then((result) => result.data);
    },
    updatecheckin: async (data: Icheckin, user: string | null) => {
      return await axiosInstance
        .put(`${apiBaseUrlUser}/${user}`, data)
        .then((result) => result.data);
    },
  };
};
